// extracted by mini-css-extract-plugin
export default {"link":"logo_link__mxl86","img":"logo_img__KI2M8"};